import { object, number, AnySchema, ValidationError } from 'yup'
import { TFunction } from 'i18next'

import { TABLE_MAX_COLUMNS, TABLE_MAX_ROWS, TABLE_MIN_COLUMNS, TABLE_MIN_ROWS } from '../../const/validation'

export type FormValidationError = ValidationError | null

export const getInsertTableSchema = (t: TFunction): AnySchema =>
  object().shape({
    rows: number()
      .min(TABLE_MIN_ROWS, t('shell.markdown-editor.min-rows'))
      .max(TABLE_MAX_ROWS, t('shell.markdown-editor.max-rows'))
      .transform((_, val) => +val)
      .required(),
    columns: number()
      .min(TABLE_MIN_COLUMNS, t('shell.markdown-editor.min-columns'))
      .max(TABLE_MAX_COLUMNS, t('shell.markdown-editor.max-columns'))
      .transform((_, val) => +val)
      .required(),
  })
